"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        width: '100%',
        height: 36,
        lineHeight: '17px',
        '& input': {
            paddingRight: 0,
            textOverflow: 'ellipsis'
        },
        '&[data-embed-list=true]': {
            height: 'unset'
        }
    },
    arrowIcon: {
        cursor: 'pointer',
        color: theme.indigo2,
        transition: 'transform 0.3s ease-in-out, color 150ms linear 0ms',
        '&[data-is-down=true]': {
            transform: 'rotate(180deg)',
            color: theme.grey1
        }
    },
    clearIcon: {
        cursor: 'pointer',
        color: theme.grey1
    },
    searchIcon: {
        color: theme.grey5
    },
    optionsList: {
        maxHeight: 200,
        position: 'relative',
        top: 5,
        left: 0,
        zIndex: 3,
        background: theme.white1,
        border: `1px solid ${theme.indigo3}`,
        borderRadius: 2,
        width: 'fit-content',
        minWidth: '100%',
        fontSize: 14,
        lineHeight: '18px',
        color: theme.grey3,
        whiteSpace: 'pre',
        overflowX: 'hidden',
        overflowY: 'auto',
        '&::placeholder': {
            color: theme.grey4
        },
        '&::-webkit-scrollbar': {
            cursor: 'pointer',
            width: 5
        },
        '&::-webkit-scrollbar-track': {
            background: theme.grey8,
            borderRadius: 10
        },
        '&::-webkit-scrollbar-thumb': {
            background: theme.grey4,
            borderRadius: 10,
            '&:hover': {
                background: theme.grey3
            }
        },
        '&[data-has-shadows=true]': {
            border: 'none',
            boxShadow: theme.indigoShadow1
        }
    },
    noMatch: {
        overflow: 'hidden',
        cursor: 'not-allowed',
        padding: '11px 10px'
    }
});
//# sourceMappingURL=smartDropdown.style.js.map